module.exports = __webpack_public_path__ + "static/media/university-alternative-entry.4deb2e65.jpg";